import React from "react";

import img1 from "images/path74.png";
import img2 from "images/path78.png";
import img3 from "images/path92.png";
import img4 from "images/path126.png";

const Cena = () => {
	return (
		<section className="module" id="services">
			<div className="container">
				<div className="row">
					<div className="col-sm-2 col-sm-offset-5">
						<div className="alt-module-subtitle">
							<span className="holder-w"></span>
							<h5 className="font-serif">La formula</h5>
							<span className="holder-w"></span>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<h3 className="module-title font-alt">
							Mar-Ven 19:30-22:30
							<br />
							Sab 12:00-14:15
						</h3>
						<p className="align-center">
							Tutto cambia sempre.
							<br />
							Un menù vario e compatto che ha percorsi degustazione dedicati anche alla
							tradizione, alla parte vegan o alla mano della cucina.
						</p>
						<br />
					</div>
				</div>
				<div className="row multi-columns-row">
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>PRE-ANTIPASTI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>15/16/20
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Salumi selezionati e formaggi da dispensa. OGNI SETTIMANA LA PROPOSTA PUO'
									VARIARE
								</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>ANTIPASTI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>15
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Carne, pesce, vegetariano e vegan. OGNI SETTIMANA PROPOSTE DIVERSE
								</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>PRIMI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>16
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Di carne, pesce, vegano, vegan e tradizione. OGNI SETTIMANA PROPOSTE DIVERSE
								</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>SECONDI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>19
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Di carne, pesce, vegetariano, vegan e della tradizione. OGNI SETTIMANA CON
									PROPOSTE DIVERSE
								</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>LA GRIGLIA</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>20/30
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Dai primi di pasta fresca affumicati e fatti a estro, alla selezione di carni o
									brace dei pesci. OGNI SETTIMANA TAGLI DI CARNE E PESCE DIVERSI
								</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4">
						<div className="price-table font-alt">
							<h4>DOLCI</h4>
							<div className="borderline"></div>
							<p className="price">
								<span>€</span>8
							</p>
							<ul className="price-details">
								<li style={{ fontWeight: "normal" }}>
									Scelta di 4/5 alternative di dolce con alternative gluten free, senza lattosio o
									vegan. OGNI SETTIMANA UNA PROPOSTA DIVERSA
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="row multi-columns-row">
					<div className="col-md-4 col-sm-6 col-xs-12">
						<div className="features-item">
							<div
								className="features-icon"
								style={{ height: 80, display: "flex", justifyContent: "center" }}>
								<img src={img1} />
							</div>
							<h3 className="features-title font-alt" style={{ textAlign: "center" }}>
								Rabarbaro Gagliardo
								<br />
								<b>[ €60 ]</b>
							</h3>
							<p style={{ textAlign: "center" }}>Degustazione di 5 portate della cucina</p>
						</div>
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<div className="features-item">
							<div
								className="features-icon"
								style={{ height: 80, display: "flex", justifyContent: "center" }}>
								<img src={img2} />
							</div>
							<h3 className="features-title font-alt" style={{ textAlign: "center" }}>
								Tradizione rivista del viaggiatore
								<br />
								<b>[ €50 ]</b>
							</h3>
							<p style={{ textAlign: "center" }}>
								Riformulazione dei classici del territorio in chiave gagliarda
							</p>
						</div>
					</div>
					<div className="col-md-4 col-sm-6 col-xs-12">
						<div className="features-item">
							<div
								className="features-icon"
								style={{ height: 80, display: "flex", justifyContent: "center" }}>
								<img src={img3} />
							</div>
							<h3 className="features-title font-alt" style={{ textAlign: "center" }}>
								Modalità eco-vegan
								<br />
								<b>[ €50 ]</b>
							</h3>
							<p style={{ textAlign: "center" }}>
								Degustazione vegetale di 4 portate dalla cucina
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Cena;
